<template>
  <div>
    <div class="h-dialogContainer">
      <template>
        <ParseForm
          ref="dnnBaseInfoId" :formId="formItems.dnnBaseInfoId.formId" :formParams="formItems.dnnBaseInfoId.formObj" :opCode="parseOpCode"></ParseForm>
      </template>
      <template>
        <ParseForm ref="dnnParamInfoId" :formId="formItems.dnnParamInfoId.formId" :formParams="formItems.dnnParamInfoId.formObj" :opCode="parseOpCode"  :Title="formItems.dnnParamInfoId.title"></ParseForm>
      </template>  
      <template>
        <ParseForm ref="pduSessionParamId" :formId="formItems.pduSessionParamId.formId" :formParams="formItems.pduSessionParamId.formObj" :opCode="parseOpCode"  :Title="formItems.pduSessionParamId.title"></ParseForm>
      </template>  
      <template>
        <ParseForm ref="sccModeParamId" :formId="formItems.sccModeParamId.formId" :formParams="formItems.sccModeParamId.formObj" :opCode="parseOpCode" :Title="formItems.sccModeParamId.title"></ParseForm>
      </template>  
      <template>
        <ParseForm ref="qosParamId" :formId="formItems.qosParamId.formId" :formParams="formItems.qosParamId.formObj" :opCode="parseOpCode" :Title="formItems.qosParamId.title"></ParseForm>
      </template>  
    </div>
  </div>
</template>

<script>
import ParseForm from "../../../util/parseFormNew/ParseForm";
import SubscriberTool from "../../../util/parseFormNew/tools/subscriberTool";
import ajaxUrl from "../../../data/ajaxUrl";
//dnnBaseInfoId;dnnParamInfoId;pduSessionParamId;sccModeParamId;qosParamId
export default {
  name: "AddProfileForm",
  components: {
    ParseForm
  },
  methods: {
    getDatas() {
      const map = new Map();
      if (this.$refs.dnnBaseInfoId) {
        if (!this.$refs.dnnBaseInfoId.validateResult()) {
          console.log("表单验证不通过");
          return;
        }
        const maps = this.$refs.dnnBaseInfoId.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      if (this.$refs.dnnParamInfoId) {
        if (!this.$refs.dnnParamInfoId.validateResult()) {
          console.log("表单验证不通过");
          return;
        }
        const maps = this.$refs.dnnParamInfoId.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      if (this.$refs.pduSessionParamId) {
        if (!this.$refs.pduSessionParamId.validateResult()) {
          console.log("表单验证不通过");
          return;
        }
        const maps = this.$refs.pduSessionParamId.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      if (this.$refs.sccModeParamId) {
        if (!this.$refs.sccModeParamId.validateResult()) {
          console.log("表单验证不通过");
          return;
        }
        const maps = this.$refs.sccModeParamId.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      if (this.$refs.qosParamId) {
        if (!this.$refs.qosParamId.validateResult()) {
          console.log("表单验证不通过");
          return;
        }
        const maps = this.$refs.qosParamId.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      return map;
    },
    getJson(ne, callback) {
      const params = {
        msgid: this.msgId,
        neid: ne.neid
      };


      this.$axios.post(ajaxUrl.udmJsonReq, params).then(response => {
     // this.$axios.post(ajaxUrl.addPdnProfileJson, params).then(response => {

        if (!response) {
          console.log("getJson response error");
          return;
        }
        if (!response.data) {
          console.log("getJson response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("getJson response.data.resultVal error");
          return;
        }
        if (response.data.errorCode !== "0") {
          console.log("1244getJson response.data.errorCode error");
          callback(response);
          return;
        }
        const res = response.data.resultVal;
        const sub = new SubscriberTool();
        const resultMap = sub.$devideByGroupBy(res, []);
        this.formItems.dnnBaseInfoId.formObj = resultMap.get(
          this.formItems.dnnBaseInfoId.modelName
        );
        this.formItems.dnnParamInfoId.formObj = resultMap.get(
          this.formItems.dnnParamInfoId.modelName
        );
        this.formItems.pduSessionParamId.formObj = resultMap.get(
          this.formItems.pduSessionParamId.modelName
        );
        this.formItems.sccModeParamId.formObj = resultMap.get(
          this.formItems.sccModeParamId.modelName
        );
        this.formItems.qosParamId.formObj = resultMap.get(
          this.formItems.qosParamId.modelName
        );

         callback(response);
      });
    },
    saveProfile(ne, callback) {
      const formData = this.getDatas();
      if (formData) {
        let pduSessionTypeList=[];
        let pduSessionTypeStr=formData.get("pduSessionType");
        if(pduSessionTypeStr>=16){
          pduSessionTypeStr=formData.get("pduSessionType").toString(2);
          pduSessionTypeList=[parseInt(pduSessionTypeStr[4]),parseInt(pduSessionTypeStr[3]),parseInt(pduSessionTypeStr[2]),parseInt(pduSessionTypeStr[1]),parseInt(pduSessionTypeStr[0])];
        }else{
          pduSessionTypeStr=formData.get("pduSessionType").toString(2);
          var pduSessionTypeSize = pduSessionTypeStr.length;    //获取要格式化数字的长度，如二进制1的话长度为1
          if(pduSessionTypeSize < 4){     //补全位数 0000，这里我要显示4位
            for(var i = 0; i < 4-pduSessionTypeSize; i++) {
              pduSessionTypeStr = "0" + pduSessionTypeStr;     //不够的就在前面补0
            }
          }
          pduSessionTypeList=[parseInt(pduSessionTypeStr[3]),parseInt(pduSessionTypeStr[2]),parseInt(pduSessionTypeStr[1]),parseInt(pduSessionTypeStr[0]),0];
        }
        let sscModeStr=formData.get("sscMode").toString(2);
        var sscModeSize = sscModeStr.length;    
        if(sscModeSize < 4){    
           for(var i = 0; i < 4-sscModeSize; i++) {
            sscModeStr = "0" + sscModeStr;     
           }
        }
        let sscModeList=[parseInt(sscModeStr[3]),parseInt(sscModeStr[2]),parseInt(sscModeStr[1])];
        const params = {
          vo: {
            neid: ne.neid,
            profileId: parseInt(formData.get("profileId")),
            profileName: formData.get("profileName"),
            dnnName: formData.get("dnnName"),
            ambrUp: parseInt(formData.get("ambrUp")),
            ambrDown: parseInt(formData.get("ambrDown")),
            chargeChars: formData.get("chargeChars"),
            pduSessionType: pduSessionTypeList,
            dftPduSessionType: formData.get("dftPduSessionType"),
            sscMode: sscModeList,
            dftSscMode: formData.get("dftSscMode"),
            fiveQi: parseInt(formData.get("fiveQi")),
            fiveQiPriorityLevel: parseInt(formData.get("fiveQiPriorityLevel")),
            pl: formData.get("pl"),
            pev: formData.get("pev"),
            pec: formData.get("pec")
          },
          info: {
            msgid: this.msgId,
            neid: ne.neid
          }
        };
        console.log("params",params);
        this.$axios.post(ajaxUrl.requestCommonD, params).then(response => {
          if (callback) {
            callback(response);
          }
        });
      }
    },
  },
  data() {
    return {
      formItems: {
        dnnBaseInfoId: {
          formId: "DNNAddBaseInfo",
          modelName: "dnnBaseInfoId",
          formObj: null
        },
        dnnParamInfoId: {
          title: this.$t("DNN.dnnParamInfo"),
          formId: "DNNAddParamInfo",
          modelName: "dnnParamInfoId",
          formObj: null
        },
        pduSessionParamId: {
          title: this.$t("DNN.pduSessionParamInfo"),
          formId: "DNNAddPduSession",
          modelName: "pduSessionParamId",
          formObj: null
        },
        sccModeParamId: {
          title: this.$t("DNN.sscModeParamInfo"),
          formId: "DNNAddSccMode",
          modelName: "sccModeParamId",
          formObj: null
        },
        qosParamId: {
          title: this.$t("DNN.qosParamInfo"),
          formId: "DNNAddQos",
          modelName: "qosParamId",
          formObj: null
        },
      },
      opCode: "add",
      msgId: "28672"    };
  },
  computed: {
    parseOpCode() {      
      return this.opCode + '';
    }
  }
};
</script>
